module.exports = __webpack_public_path__ + "static/Proposal-Boards-2a56d146df9fe4aad12822073270b01c.png";